import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '桃花视频',
    url: 'https://taohuavideo.com',
    description: '桃花视频汇集香蕉视频、糖豆视频、小蓝视频、蓝莓视频等热门影视资源，提供高清免费在线观看。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://taohuavideo.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '桃花视频',
    url: 'https://taohuavideo.com',
    description: '专业的影视资源聚合平台，提供高清在线观看服务。',
    sameAs: [
      'https://weibo.com/taohuavideo',
      'https://www.zhihu.com/org/taohuavideo',
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <LatestSection />

        {/* CTA Section */}
        <section className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16 bg-primary-500">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
              随时随地，畅享高清影视
            </h2>
            <p className="text-sm md:text-base text-white/80 mb-6 leading-relaxed">
              桃花视频持续更新最新影视资源，香蕉视频、糖豆视频、小蓝视频、蓝莓视频多平台聚合，追剧不等待
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="/category/dianshiju"
                className="px-8 py-3 bg-white text-primary-600 font-medium rounded-full text-sm hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
              >
                立即观看 <i className="ri-play-circle-line ml-1"></i>
              </a>
              <a
                href="/about"
                className="px-8 py-3 bg-white/15 text-white font-medium rounded-full text-sm hover:bg-white/25 backdrop-blur-sm transition-all cursor-pointer whitespace-nowrap"
              >
                了解更多 <i className="ri-information-line ml-1"></i>
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}